// Lightweight platform detection used by the onboarding flow + push
// subscribe widget. Browsers don't expose this cleanly so we sniff UA.
// Good enough for our four-person, known-device audience.

export function detectPlatform() {
  if (typeof window === 'undefined') return { os: 'unknown', standalone: false };
  const ua = window.navigator.userAgent || '';
  const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
  const isAndroid = /Android/.test(ua);
  const isStandalone =
    window.matchMedia?.('(display-mode: standalone)').matches ||
    window.navigator.standalone === true;
  let os = 'desktop';
  if (isIOS) os = 'ios';
  else if (isAndroid) os = 'android';
  return { os, isIOS, isAndroid, standalone: isStandalone };
}

const ONBOARDING_KEY = 'somesay_onboarding_done';

export function markOnboardingDone() {
  try {
    window.localStorage.setItem(ONBOARDING_KEY, new Date().toISOString());
  } catch {
    // ignore
  }
}

export function onboardingDone() {
  try {
    return !!window.localStorage.getItem(ONBOARDING_KEY);
  } catch {
    return false;
  }
}

export function clearOnboardingFlag() {
  try {
    window.localStorage.removeItem(ONBOARDING_KEY);
  } catch {
    // ignore
  }
}
